import { Component, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { ScorecardDataService } from '../core/data.service';
import { OverallScoreData } from '../core/overall-score-data.model';
import { OverallScoreGridOptions } from '../core/overall-score-grid-options.model';
import { Widget, WidgetType } from '../core/template-definition.model';
import { TrendType } from '../core/trend-type.model';
import { TranslationKeyMap } from '../scorecard.i18n';
import { CMPS_SCORECARD_WIDGET } from '../scorecard.metadata';
import { OverallScore } from '../scorecard.model';

@Component({
    selector: 'cmps-scorecard-overallscore-widget',
    templateUrl: './overall-score-widget.component.html',
    host: {
        class: 'cmps-scorecard-overallscore-widget',
    },
})
@TakeUntilDestroy()
export class ScOverallScoreWidgetComponent implements OnInit {
    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _collapsed: boolean;
    /** @private */ _overallScores: OverallScore[];
    /** @private */ _data: OverallScoreData;
    /** @private */ _TrendType = TrendType;

    /** @private */ get _isLoadingData(): Observable<boolean> {
        return this._loadingData.asObservable();
    }

    private readonly _loadingData: BehaviorSubject<boolean>;

    public headerColour: string;
    public headerTextColour: string;
    public backgroundColour: string;
    public textColour: string;

    constructor(
        private readonly _dataService: ScorecardDataService,
        @Inject(CMPS_SCORECARD_WIDGET) /** @private */
        public _widget: Widget<OverallScoreGridOptions>,
    ) {
        this.headerColour = _widget.headerColour;
        this.headerTextColour = _widget.headerTextColour;
        this.backgroundColour = _widget.backgroundColour;
        this.textColour = _widget.textColour;
        this._loadingData = new BehaviorSubject<boolean>(false);
    }

    ngOnInit(): void {
        this._dataService
            .observableForWidgetType<OverallScoreData>(
                WidgetType.OVERALL_SCORE_GRID,
            )
            .pipe(
                tap((data) => {
                    this._data = data;
                    this._overallScores = (data ? data.scores : null) || [];
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
